import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '../ui/dialog';
import { AgentButton } from './AgentPageLayout';
import { ExclamationTriangleIcon } from '@heroicons/react/24/solid';

interface SecurityViolationModalProps {
  open: boolean;
  onClose: () => void;
  onRestart: () => void;
}

const SecurityViolationModal: React.FC<SecurityViolationModalProps> = ({
  open,
  onClose,
  onRestart,
}) => {
  const handleRestart = () => {
    onRestart();
    onClose();
    // Recarregar a página
    window.location.reload();
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="flex items-center gap-3 mb-2">
            <ExclamationTriangleIcon className="w-8 h-8 text-red-600" />
            <DialogTitle className="text-red-600 font-bold text-xl">
              Atenção!
            </DialogTitle>
          </div>
          <DialogDescription asChild>
            <div className="mt-4 text-base text-foreground">
              <p className="mb-4">
                Alguns termos digitados contrariam as normas da plataforma. Não são admitidos palavrões, ofensas, termos de cunho racial e etc.
              </p>
            </div>
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex-col sm:flex-row gap-2">
          <AgentButton
            type="button"
            onClick={handleRestart}
            className="w-full sm:w-auto"
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-5" aria-hidden="true">
              <path strokeLinecap="round" strokeLinejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
            </svg>
            <span>Reiniciar</span>
          </AgentButton>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default SecurityViolationModal;
